'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
mmWidgets.fn.atlasRepublishingWidget = function (atlasModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			slugField = element.find('[data-mm-export-parameter~="slug"]'),
			showForType = function (type) {
				const matching = element.find('[data-mm-atlas-publishing~="' + type + '"]');
				element.find('[data-mm-atlas-publishing]').addClass('hidden');
				matching.removeClass('hidden');
				return matching.length;
			},
			showError = function (reason) {
				if (!showForType('error-' + reason)) {
					showForType('error');
				}
				element.trigger('errorShown');
			},
			checkForExists = function () {
				const slug = slugField.val();
				showForType('checking');
				atlasModel.slugExists(slug).then(function (exists) {
					const publishingVal = exists ? 'published' : 'not-published';
					showForType(publishingVal);
					element.trigger('checkForExistsFinished');
				}, showError);
			};
		slugField.on('checkForExists', checkForExists);
		element.on('publishResult', checkForExists);
		element.find('[data-mm-role~="unpublish-atlas"]').click(function () {
			const slug = slugField.val();
			element.showSection('unpublishing');
			atlasModel.removePublishedMap(slug).then(function () {
				showForType('not-published');
				element.showSection('unpublished');
				element.trigger('unpublishFinished');
			}, showError);
		});
	});
};
